import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "./AuthContext";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen hero-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-white font-[Poppins] font-bold text-[22px] tracking-tight">PATRICK GLOBAL</div>
          <div className="text-[11px] tracking-[0.2em] text-[var(--pg-accent)] uppercase font-semibold mt-1">Procurement Platform · Admin</div>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl">
          <div className="w-12 h-12 rounded-xl bg-[var(--pg-navy)] text-white flex items-center justify-center mb-5"><Lock size={20} /></div>
          <h1 className="font-[Poppins] font-bold text-[22px] text-[var(--pg-navy)]">Sign in</h1>
          <div className="mt-5">
            <label className="pg-label" htmlFor="admin-email">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" className="pg-input" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" />
          </div>
          <div className="mt-4">
            <label className="pg-label" htmlFor="admin-password">Password</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" className="pg-input" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
          </div>
          {error && <p data-testid="admin-login-error" className="mt-4 text-[13.5px] text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</p>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center mt-6 disabled:opacity-70">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
